import { Injectable, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { map, distinctUntilChanged, tap } from 'rxjs/operators';

import { ApiService } from './api.service';
import { JwtTokenService } from './jwtToken.service';

import { environment } from '../../../environments/environment';
import { jwtDecode } from 'jwt-decode';

export interface User {
  jwt_token: string;
  refresh_token: string;
  actual_user: boolean;
  registration_mandate?: boolean;
  user_details: any;
  user_uuid: any;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private jwtService: JwtTokenService
  ) {}

  authenticateUser(loginUserData: Object): Observable<any> {
    return this.apiService
      .post('api/v1/nladmin/auth/login/', loginUserData)
      .pipe(
        map((data) => {
          if (data.status_code === -1) {
            //alertify.error(data?.status_message);
            return data;
          } else {
            this.setAuthCredentials(data.results);
            //alertify.set('notifier', 'position', 'top-right');
            //alertify.success('You have successfully logged in!').delay(3);
            return data.results;
          }
        })
      );
  }

  setAuthCredentials(user: User) {
    this.jwtService.saveToken(user.jwt_token);
    this.jwtService.saveRefreshToken(user.refresh_token);
    let decodedData: any = jwtDecode(user.jwt_token);
    //this.currentUserSubject.next(user);
    //this.userDetails.next(user.user_details);
    const userUuid = decodedData?.user_uuid || 'default-uuid';
    user['user_uuid'] = userUuid;

    // Save the updated user object in localStorage
    localStorage.setItem('userDetails', JSON.stringify(user));
    // if (user?.actual_user) {
    // 	this.isAuthenticatedUserSubject.next(true);
    // }
  }

  getUserDetails() {
    const userDetails = localStorage.getItem('userDetails');

    if (userDetails) {
      return JSON.parse(userDetails);
    } else {
      return null;
    }
  }

  logoutUser() {
    localStorage.removeItem('userDetails');
    this.jwtService.destroyToken();
  }

  deleteAuthCredentials() {
    //this.isAuthenticatedUserSubject.next(false);
    //this.currentUserSubject.next({} as User);
    //this.userDetails.next({});
    localStorage.removeItem('userDetails');
    //localStorage.removeItem('googleDeatils');
    this.jwtService.destroyToken();
  }

  refreshAccessToken() {
    const tokenData = {
      device_type: 'WEB',
    };
    const path = 'api/v1/auth/refresh-access-token/';
    const url = `${environment.api_url}${path}`;
    return this.http.post<any>(url, tokenData).pipe(
      tap((data: any) => {
        this.jwtService.saveToken(data.results.token);
      })
    );
  }

  changePassword(requestObj: any) {
    return this.apiService
      .post('api/v1/settings/update-password/', requestObj)
      .pipe(
        map((data) => {
          if (!data) {
            throw Error;
          } else {
            if (data.status_code === -1) {
              throw data.status_message;
            } else {
              return data.results;
            }
          }
        })
      );
  }
}
